import Widget from 'widget/Widget';
import BaseMapLayer from '../layers/BaseMapLayer';
import Utils from 'helpers/Utils';
import MeliaHelpers from '../helpers/MeliaServiceHelper';
import jQuery from 'jquery';
import { DESTINATIONS_TREE } from '../globals/widgetTypes';

/*eslint-disable */
import flatMap from 'array.prototype.flatmap';
delete Array.prototype.flatMap;
Array.prototype.flatMap = flatMap.getPolyfill();
Math.trunc = Math.trunc || function (x) {
	return (x < 0 ? Math.ceil(x) : Math.floor(x));
}
/*eslint-enable */

export default Widget.extend({
	validation: require('./meliaWidget.schema.json'),

	constructor(containerId, config, api) {
		if (this.typeWidget !== DESTINATIONS_TREE) {
			config = this.loadConfigCenter(config);
			config = this.loadConfigPoiVisibility(config);
		}
		this.isMobileVersion = config.mobileVersion;
		this.typeWidget = config.typeWidget;
		Widget.prototype.constructor.call(this, containerId, config, api);
	},

	createIcon(object) {
		return {
			url: Utils.getImgUrl(object.mainHotel.iconMarker, this),
			size: new google.maps.Size(50, 50),
			scaledSize: new google.maps.Size(50, 50)
		};
	},

	initialize() {
		Widget.prototype.initialize.call(this);
	},
	
	onInitialized() {
		if (this.map && !this.isMobileVersion) {
			this.map.zoomControl = true;
		}
	},

	initBaseMapLayer() {
		return this.addLayer(
			new BaseMapLayer({
				widget: this,
				id: 'BaseMapLayer'
			})
		);
	},

	loadConfigCenter(config) {
		if (config.hotels) {
			this.hotelsJson = config.hotels;
			if (config.hotels.mainHotel) {
				config.defaultView.center[0] =
					config.hotels.mainHotel.position.lat;
				config.defaultView.center[1] =
					config.hotels.mainHotel.position.lng;
			}
		}
		return config;
	},

	loadConfigPoiVisibility(config) {
		if (config.poiVisibility === undefined) {
			config.poiVisibility = 'on';
		} else {
			config.poiVisibility = config.poiVisibility ? 'on' : 'off';
		}
		if (!(config.mapOptions && config.mapOptions.styles)) {
			config.mapOptions = { styles: [] };
			config.mapOptions.styles = [
				{
					featureType: 'poi',
					stylers: [{ visibility: config.poiVisibility }]
				}
			];
		}

		return config;
	},

	addMarkerToLayer(layerId, object, icon) {
		return this.handleLayers.layers[
			this.handleLayers.getLayerIndex(layerId)
		].addMarker(object, icon);
	},

	getHeight() {
		return this.$el.height();
	},

	getMainHotelData(id) {
		const deferred = jQuery.Deferred();
		const arrPromises = [
			MeliaHelpers.getHotelDetails(
				this.config.MeliaUrls,
				id,
				this.config.gmapLoadConfig.LANGUAGE
			),
			MeliaHelpers.getHotelPrices(
				this.config.MeliaUrls,
				id,
				this.config.currency,
				this.config.country
			)
		];

		jQuery.when
			.apply(jQuery, arrPromises)
			.then((hotelData, hotelPrices) => {
				const jQueryPricesElement = jQuery(hotelPrices);
				hotelData.hotel.hotelSection.lowestPrice = jQueryPricesElement
					.find('LowestPrice')
					.text();
				hotelData.hotel.hotelSection.regularPrice = jQueryPricesElement
					.find('RegularPrice')
					.text();
				this.hotelSelectedData = hotelData;
				if (this.config.MeliaUrls.friendlyUrl) {
					MeliaHelpers.getHotelURL(
						this.config.MeliaUrls,
						id,
						hotelData.hotel.hotelSection.name,
						this.config.gmapLoadConfig.LANGUAGE
					).then(hotelFriendlyURL => {
						hotelData.hotel.hotelSection.url = hotelFriendlyURL;
					}).fail(() => {
						console.warn('FriendlyUrl FAIL');
					}).always(() => {
						deferred.resolve(hotelData);
					});
				} else {
					deferred.resolve(hotelData);
				}
			});
		return deferred.promise();
	},

	getDestinationsTreeObject(regionID) {
		const deferred = jQuery.Deferred();
		if (this.destinationsTree) {
			const filteredHotels = this.getHotelsByRegionID(
				this.destinationsTree,
				regionID
			);
			deferred.resolve(filteredHotels);
		} else {
			MeliaHelpers.getDestinationsTree(
				this.config.MeliaUrls,
				this.config.gmapLoadConfig.LANGUAGE
			).then(destinationsData => {
				this.destinationsTree = this.flatHotelsDestinationsTreeData(
					destinationsData
				);
				const filteredHotels = this.getHotelsByRegionID(
					this.destinationsTree,
					regionID
				);
				deferred.resolve(filteredHotels);
			});
		}
		return deferred.promise();
	},

	flatHotelsDestinationsTreeData(destinationsTreeData) {
		let continentUID, countryUID, regionUID;
		const totalHotels = destinationsTreeData.searchData.flatMap(
			subCatContinent => {
				continentUID = subCatContinent.category.uid;
				return subCatContinent.subCategories.flatMap(subCat => {
					countryUID = subCat.category.uid;
					return subCat.subCategories
						.filter(subC => !!subC.hotels)
						.flatMap(subCatFinale => {
							regionUID = subCatFinale.category.uid;
							return subCatFinale.hotels.map(hotel => {
								if (!hotel.lat || !hotel.lon) {
									console.warn(`${hotel.hotelCode} ---> lat: ${hotel.lat}/lng: ${hotel.lon}`);
									return false;
								} else {
									hotel.position = {
										lat: parseFloat(hotel.lat),
										lon: parseFloat(hotel.lon)
									};
									hotel.parentsUID = [
										continentUID,
										countryUID,
										regionUID
									];
									return hotel;
								}
							});
						});
				});
			}
		);
		return totalHotels;
	},

	getHotelsByRegionID(totalHotels, regID) {
		const uniqueHotelsByRegId = totalHotels
			.filter(hotel => {
				return !!hotel && hotel.parentsUID.includes(regID);
			})
			.filter((hotel, index, allHotels) => {
				return (
					allHotels
						.map(hotelsByRegId => hotelsByRegId['hotelCode'])
						.indexOf(hotel['hotelCode']) === index
				);
			});
		return uniqueHotelsByRegId;
	}
});



// WEBPACK FOOTER //
// ./src/widget/MeliaWidget.js